/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Add_SetInputs */

const en_us2_workout_add_set = /** @type {(inputs: Workout_Add_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a set`)
};

const pt_br2_workout_add_set = /** @type {(inputs: Workout_Add_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar uma série`)
};

const es_419_workout_add_set = /** @type {(inputs: Workout_Add_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar una serie`)
};

const pt_pt2_workout_add_set = /** @type {(inputs: Workout_Add_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar uma série`)
};

const fr_fr2_workout_add_set = /** @type {(inputs: Workout_Add_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une série`)
};

const de_de2_workout_add_set = /** @type {(inputs: Workout_Add_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Satz hinzufügen`)
};

const it_it2_workout_add_set = /** @type {(inputs: Workout_Add_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi una serie`)
};

/**
* | output |
* | --- |
* | "Add a set" |
*
* @param {Workout_Add_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_add_set = /** @type {((inputs?: Workout_Add_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Add_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_add_set(inputs)
	if (locale === "es-419") return es_419_workout_add_set(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_add_set(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_add_set(inputs)
	if (locale === "de-DE") return de_de2_workout_add_set(inputs)
	if (locale === "it-IT") return it_it2_workout_add_set(inputs)
	return en_us2_workout_add_set(inputs)
});
export { workout_add_set as "workout.add_set" }